import React  from "react";
import PropTypes from "prop-types";
import CustomTableList from "./customTableList";
import Pagination from "../../pagination";
import FormGroupSelectInput from "../../formGroupSelectInput";
import MediaQuery from "react-responsive";
import TableAccordion from "./tableAccordion";
import Loader from "../loader/loader";
import SelectableActionsForm from "./selectableActionsForm";


class CustomTable extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            expandedTableRows: [],
            expandedAccordionItems: []
        }
    }

    // for accordion
    onExpandAccordionItems = (datumIndex) => {
        if (this.state.expandedAccordionItems.includes(datumIndex)) {
            this.setState({
                ...this.state,
                expandedAccordionItems: this.state.expandedAccordionItems.filter(item => item !== datumIndex)
            });
        } else {
            this.setState({
                ...this.state,
                expandedAccordionItems: [
                    ...this.state.expandedAccordionItems,
                    datumIndex
                ]
            });
        }
    };

    //for expandable table rows
    setExpandedTableRows = (expandedTableRows) => {
        this.setState({
            ...this.state,
            expandedTableRows
        })
    };

    onTableRowExpand = (datumIndex) => {
        if (this.state.expandedTableRows.includes(datumIndex)) {
            this.setExpandedTableRows(this.state.expandedTableRows.filter(item => item !== datumIndex));
        } else {
            this.setExpandedTableRows([...this.state.expandedTableRows, datumIndex]);
        }
    };

    render(){
        const {
            columns,
            data,
            loading,
            selectable,
            striped,
            responsive,
            selectActions,
            actionResultLoading,
            page,
            pageSize,
            goAtPrevious,
            goAtNext,
            goAtEnd,
            goAtStart,
            goAtPage,
            totalPages,
            onDatumSelect,
            selected,
            onSelectAll,
            pageSizeOptions,
            onPageSizeChange,
            onSelectAction,
            selectedAction,
            onSelectedActionApply,
            totalRecords,
            orderBy,
            orderAsc,
            onSortedChange,
            accordionItemHeaderFormatter,
            renderAsTableAccordion,
            expandableRow,
            hasActions,
            nestedTableTitle,
            tableHover,
            customNestedTableComponent,
            onPageShift,
            fixed
        } = this.props;

        
        const totalColumns = columns.length + (expandableRow ? 1 : 0) + (hasActions ? 1 : 0) + (selectable ? 1 : 0); //plus one for the column with the expand btn
        return (
            <div>
                    {(!!page) && (
                        <div className={'row'}>
                            <form className={"form-horizontal"}>
                                <div className={'col-sm-2'}>
                                    <FormGroupSelectInput
                                        labelClassName={'removePadding'}
                                        Label="View"
                                        LeftWrapper="col-sm-4 labelVerticalCentering"
                                        Value={pageSize}
                                        Name="selectedView"
                                        HandleInputChange={onPageSizeChange}
                                        Options={pageSizeOptions}
                                        CenterWrapper="col-sm-8 formGroupSelectInput-select-wrapper"
                                        RightWrapper="" Required={false}
                                        SelectStyle={'form-control formGroupSelectInput-select'}
                                    />
                                </div>
                            </form>
                        </div>
                    )}
                    {selectable && (
                        <SelectableActionsForm {...this.props}/>
                    )}
                    {loading && (
                        <Loader variant="list" />
                    )}
                    {!loading && (
                        [
                            <MediaQuery query="(max-device-width: 768px)" key={1}>
                                <TableAccordion
                                    expandedAccordionItems={this.state.expandedAccordionItems}
                                    onExpandAccordionItems={this.onExpandAccordionItems}
                                    expandedTableRows={this.state.expandedTableRows}
                                    onTableRowExpand={this.onTableRowExpand}
                                    {...this.props}
                                    totalColumns={totalColumns}
                                />
                            </MediaQuery>,
                            <MediaQuery query="(min-device-width: 769px)" key={2}>
                                <CustomTableList
                                    expandedTableRows={this.state.expandedTableRows}
                                    onTableRowExpand={this.onTableRowExpand}
                                    {...this.props}
                                    totalColumns={totalColumns}
                                />
                            </MediaQuery>,
                            page ?
                                <Pagination
                                    key={3}
                                    PageShift={onPageShift}
                                    HandleInputChange={goAtPage}
                                    TotalDisplayBoxes={totalPages}
                                    TotalRecords={totalRecords}
                                    Page={page}
                                    SelectedView={parseInt(pageSize)}
                                    DataLength={data.length}
                                />
                                :
                                null
                        ]
                    )}
                </div>
        );
    }
};

CustomTable.propTypes = {
    /** Array that contains the rows indexes that should have a loader */
    loadingRows: PropTypes.arrayOf(PropTypes.number),
    /** boolean indicating that the table should have a vertical aligned header */
    withVerticalAlignedHeader: PropTypes.bool,
    /** boolean indicating that when the table has actions they should appear on the left of the table */
    actionOnLeft: PropTypes.bool,
    /** Boolean prop that when is set to true an extra column will be displayed to display the actions - links.
     * If set to true the property actions must be specified */
    hasActions: PropTypes.bool,
    /** The columns of the list - table. The propertyName is used to match the desired property of the data objects.
     * eg: the data object {email : "user@test.io"} will be matched by the column: {propertyName: "email", header:
     * "Email!"}. If you wish to access nested properties from the data you should specify them again in the
     * propertyName separated with a dot "." eg: data: {user: {email : "user@test.io"}}, then the property name will be
     * propertyName: "user.email". The id property of is used for sorting. So it must match the correct sortBy key.
     * The formatter is a callback used to format the data as you wish. It is invoked with the datum. For example
     * formatting timestamp dates. the sortable prop specifies if the column is sortable
     * . The style property can be used to style the th as you want. The sorting style property can be used to
     * style the sorting arrows of the th as you want.*/
    columns: PropTypes.arrayOf(PropTypes.shape({
        propertyName: PropTypes.string.isRequired,
        header: PropTypes.string.isRequired,
        id: PropTypes.string,
        formatter: PropTypes.func,
        sortable: PropTypes.bool,
        style: PropTypes.object,
        sortingStyle: PropTypes.object,
    })).isRequired,
    /** The data that should be displayed. Can by an array of objects of any type and shape */
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
    /** Boolean indicating that the table should be rendered only in accordion format */
    renderAsTableAccordion: PropTypes.bool,
    /** Boolean indicating that the table is loading the data */
    loading: PropTypes.bool,
    /** Boolean indicating that the items are selectable. If set to true, the props selected, onDatumSelect,
     * onSelectAll MUST be specified */
    selectable: PropTypes.bool,
    /** Object containing the selected items */
    selected: PropTypes.object,
    /** Boolean indicating if the rows should be striped */
    striped: PropTypes.bool,
    /** Boolean indicating if the table should be responsive */
    responsive: PropTypes.bool,
    /** Array of options like the SelectInput component*/
    selectActions: PropTypes.array,
    /** Boolean indicating the the action execution is loading*/
    actionResultLoading: PropTypes.bool,
    /** The current page of the pager */
    page: PropTypes.number,
    /** Number the specifies the size of each page */
    pageSize: PropTypes.number,
    /** Callback invoked when go at previous button is clicked */
    goAtPrevious: PropTypes.func,
    /** Callback invoked when  the the go at next button is clicked*/
    goAtNext: PropTypes.func,
    /** Callback invoked when the go at start button is clicked */
    goAtStart: PropTypes.func,
    /** Callback invoked when the go at end button is clicked */
    goAtPage: PropTypes.func,
    /** The total pager  items*/
    totalPages: PropTypes.number,
    /** Callback invoked  when the use checks a row - item. It will be passed with the arguments: checked(bool),
     * index(number), datum(object), eg: (checked, index, datum) => {}*/
    onDatumSelect: PropTypes.func,
    /** Callback invoked when select all input is clicked. It will be invoked with a checked bool property
     * eg: (allSelectedChecked) => {} */
    onSelectAll: PropTypes.func,
    /** Array of SelectInput options */
    pageSizeOptions: PropTypes.array,
    /** Callback fired when the user selects a page size. Similar with the onChange callback of the SelectInput
     * component*/
    onPageSizeChange: PropTypes.func,
    /** Callback fired when the user selects an action. Similar with the onChange callback of the SelectInput
     * component*/
    onSelectAction: PropTypes.func,
    /** Selected key from options. Similar with the SelectInput component */
    selectedAction: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /** Callback invoked when the user triggers an action */
    onSelectedActionApply: PropTypes.func,
    /** The total records */
    totalRecords: PropTypes.number,
    /** String that must match the sortable column id property. MUST be specified IF column is sortable*/
    orderBy: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /** Boolean indicating if the sort order is ascending or descending */
    orderAsc: PropTypes.bool,
    /** Callback invoked on sortable columns click. It will be invoked  with an argument of the column in property.
     * MUST be specified IF column is sortable*/
    onSortedChange: PropTypes.func,
    /** Callback invoked with the entire row - datum in order to format the accordion item header as you wish!*/
    accordionItemHeaderFormatter: PropTypes.func,
    /** object that describes the expandable row table. You can also add all the properties of The Table component
     * in the property nestedTableProps and they will be passed to the nested component. If you want to map-alter the
     * data before display use the dataFormatter function property. It will be called with the data for display. It
     * MUST return the altered data.*/
    expandableRow: PropTypes.shape({
        columns:  PropTypes.arrayOf(PropTypes.shape({
            propertyName: PropTypes.string,
            header: PropTypes.string,

            formatter: PropTypes.func,
        })),
        propertyNameWithData: PropTypes.string,
        dataFormatter: PropTypes.func,
        nestedTableProps: PropTypes.object
    }),
    /** The header title of the nested table of each row */
    nestedTableTitle: PropTypes.string,
    /** flag that indicates that the table should have a table-hover style */
    tableHover: PropTypes.bool,
    /** Custom component to replace the built in nested Table component of each row. It will have the
     * expandable table row passed as a prop */
    customNestedTableComponent: PropTypes.element,
    /** Array of the desired actions. The callback will be invoked when the corresponding action is clicked.
     * The callback function with have the row datum and row index passed as arguments.
     * If a custom component is defined then the actions wil be rendered according to it. The custom component will
     * also have available the props: datum, action & rowIndex */
    actions: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        callback: PropTypes.func.isRequired,
        customComponent: PropTypes.element
    })),
};

export default CustomTable;